import trackingConsole from './trackingConsole';

export interface StepTimer {
	mark: (label: string) => void;
}

const getNowMs = (): number => (typeof performance !== 'undefined' ? performance.now() : Date.now());

// logged through trackingConsole so a production run can be timed with ?test=true; the page-load offset
// lines a step up against work started elsewhere, such as the Klarna sdk loading in AppWrapper
export const startStepTimer = (name: string): StepTimer => {
	const startedAtMs = getNowMs();
	let lastMarkedAtMs = startedAtMs;

	trackingConsole.log(`[timing] ${name} started at ${Math.round(startedAtMs)}ms after page load`);

	return {
		mark: (label: string): void => {
			const markedAtMs = getNowMs();
			trackingConsole.log(`[timing] ${name} - ${label}: +${Math.round(markedAtMs - lastMarkedAtMs)}ms (${Math.round(markedAtMs - startedAtMs)}ms total, ${Math.round(markedAtMs)}ms after page load)`);
			lastMarkedAtMs = markedAtMs;
		}
	};
};
